export default function Icon({name}: {name: string}) {
  return <span className="icon material-icons">{name}</span>;
}
